import apiV2 from '../../api/v2';

export interface CreatePatientInput {
    practiceId: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    countryShortName?: 'US' | 'CA';
    gender: 'Male' | 'Female';
    dateOfBirth: string;
}

export interface PatientCreationInput {
    practiceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    countryShortName?: 'US' | 'CA';
    gender?: 'Male' | 'Female';
    dateOfBirth?: string;
    caseType?: string | null;
    subCaseType?: string | null;
    manufacturer?: string | null;
    additionalInfo?: string | null;
    photosDate?: string | null;
    patientIteroScanNumber?: string | null;
}

export interface PatientCreationResult {
    id: string;
    treatmentDuration?: string;
}

export async function createPatient(input: CreatePatientInput): Promise<PatientCreationResult> {
    const response = await apiV2.post<PatientCreationResult>('/patients', input);
    return response.data;
}

export async function updatePatientCreation(
    patientId: string,
    input: PatientCreationInput
): Promise<PatientCreationResult> {
    const response = await apiV2.patch<PatientCreationResult>(
        `/patients/${patientId}/creation`,
        input
    );
    return response.data;
}

export interface PatientCreationData {
    id: string;
    practiceId: string | null;

    firstName: string;
    lastName: string;
    email: string | null;
    phone: string | null;
    gender: string | null;
    dateOfBirth: string | null;

    caseType: string | null;
    subCaseType: string | null;
    manufacturer: string | null;
    additionalInfo: string | null;

    treatmentDuration: string | null;

    photosDate: string | null;
    patientIteroScanNumber: string | null;
}

export async function loadPatientCreation(patientId: string): Promise<PatientCreationData> {
    const response = await apiV2.get<PatientCreationData>(`/patients/${patientId}/creation`);
    return response.data;
}

export interface SubmitCaseResult {
    id: string;
}

export async function submitCase(patientId: string): Promise<SubmitCaseResult> {
    const response = await apiV2.post<SubmitCaseResult>(`/patients/${patientId}/creation/submit`);
    return response.data;
}
